if (!customElements.get("slider-element")) {
	customElements.define(
		"slider-element",
		class SliderElement extends HTMLElement {
			constructor() {
				super();

				this.slides = Array.from(this.children);
			}

			connectedCallback() {
				if (this.dataset.sliderEnable === "false") return;

				const options = {
					mousewheel: {
						forceToAxis: true,
					},
					on: {
						init: (swiper) => {
							this.swiperInstance = swiper;
							this.updateShadows(swiper);
						},
						setTranslate: (swiper) => {
							this.updateShadows(swiper);
						},
					},
				};

				if (this.dataset.autoplay) {
					options.autoplay = { delay: +this.dataset.autoplay };
				}

				if (this.dataset.autoHeight) {
					options.autoHeight = true;
				}

				if (this.dataset.centeredSlides) {
					options.centeredSlides = true;
				}

				if (this.dataset.spaceBetween) {
					options.spaceBetween = +this.dataset.spaceBetween;
				}

				if (
					this.dataset.slidesDesktop &&
					this.dataset.slidesTablet &&
					this.dataset.slidesMobile
				) {
					options.slidesPerView = +this.dataset.slidesMobile;
					options.breakpoints = {
						750: { slidesPerView: +this.dataset.slidesTablet },
						1080: { slidesPerView: +this.dataset.slidesDesktop },
					};

					this.updateSwiperDisabledState();
					const mqTablet = window.matchMedia("(min-width:750px)");
					const mqDesktop = window.matchMedia("(min-width:1080px)");
					mqTablet.addEventListener("change", () =>
						this.updateWindowsResizeEvents(this.swiperInstance)
					);
					mqDesktop.addEventListener("change", () =>
						this.updateWindowsResizeEvents(this.swiperInstance)
					);
				} else if (this.dataset.slides) {
					options.slidesPerView = +this.dataset.slides;
				} else {
					options.slidesPerView = "auto";
				}

				this.classList.add("swiper");
				const wrapper = document.createElement("div");
				wrapper.classList.add("swiper-wrapper");

				this.slides.forEach((child) => {
					child.classList.add("swiper-slide");
					wrapper.appendChild(child);
				});

				this.innerHTML = "";
				this.appendChild(wrapper);

				if (
					this.dataset.navigation === "true" ||
					this.dataset.pagination === "true"
				) {
					const elements = document.createElement("div");
					elements.classList.add(
						"swiper-elements",
						`swiper-elements__${this.dataset?.elementsPosition}`
					);
					this.appendChild(elements);
				}

				if (this.dataset.navigation === "true") {
					const arrowSvg = `
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="icon icon-arrow" viewBox="0 0 16 16">
							<path fill="currentColor" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 1 1 .708-.708l4 4 a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
						</svg> 
					`;
					const prev = document.createElement("div");
					prev.classList.add("swiper-button-prev", "animate-arrow");
					prev.innerHTML = arrowSvg;
					const next = document.createElement("div");
					next.classList.add("swiper-button-next", "animate-arrow");
					next.innerHTML = arrowSvg;
					this.querySelector(".swiper-elements").appendChild(prev);
					this.querySelector(".swiper-elements").appendChild(next);
					options.navigation = {
						nextEl: next,
						prevEl: prev,
					};
				}

				if (this.dataset.pagination === "true") {
					const pagination = document.createElement("div");
					pagination.classList.add("swiper-scrollbar");
					this.querySelector(".swiper-elements").appendChild(pagination);
					options.scrollbar = {
						el: pagination,
						draggable: true,
					};
				}

				if (typeof Swiper !== "undefined") {
					this.swiperInstance = new Swiper(this, options);
				}

				this.updateHeight();
			}

			updateWindowsResizeEvents(swiperInstance) {
				if (swiperInstance) {
					swiperInstance.update();
					setTimeout(() => {
						this.updateShadows(swiperInstance);
					}, 50);
				}
			}

			updateShadows(swiper) {
				this.classList.remove("shadow-before", "shadow-after", "no-shadow");
				if (swiper.isBeginning && !swiper.isEnd) {
					this.classList.add("shadow-after");
				} else if (swiper.isEnd && !swiper.isBeginning) {
					this.classList.add("shadow-before");
				} else if (!swiper.isBeginning && !swiper.isEnd) {
					this.classList.add("shadow-before", "shadow-after");
				} else if (swiper.isBeginning && swiper.isEnd) {
					this.classList.add("no-shadow");
				}
			}

			updateSwiperDisabledState() {
				if (+this.dataset.slidesDesktop >= this.slides.length)
					this.classList.add("swiper-disabled-desktop");
				if (+this.dataset.slidesTablet >= this.slides.length)
					this.classList.add("swiper-disabled-tablet");
				if (+this.dataset.slidesMobile >= this.slides.length)
					this.classList.add("swiper-disabled-mobile");
			}

			updateHeight() {
				this.updateAnnouncementHeight();
			}

			updateAnnouncementHeight() {
				const announcement = this.closest(".announcement__bar");

				if (
					!announcement ||
					!announcement.querySelectorAll(".announcement__item").length > 1
				) {
					return;
				}

				const announcementWrapper = document.querySelector(".announcement");
				const setAnnouncementHeight = () =>
					document.documentElement.style.setProperty(
						"--announcement-height",
						`${announcementWrapper.offsetHeight}px`
					);
				setAnnouncementHeight();
				window
					.matchMedia("(max-width: 650px)")
					.addEventListener("change", setAnnouncementHeight);
			}

			updateMainSlide(targetSlide) {
				if (!this.swiperInstance) return;

				const allSlides = Array.from(this.swiperInstance.slides);
				const targetIndex = allSlides.indexOf(targetSlide);

				if (targetIndex && targetIndex >= 0) {
					this.swiperInstance.slideTo(targetIndex, 500, false);
				}
			}
		}
	);
}
